export default function getPlanReducer
    (state = { error:null, success:null, processing:false }, action) {

    switch (action.type)
    {
        case 'GET_PLAN_SUCCESS':
            return {...state, ...{success: action.success }};

        case 'GET_PLAN_ERROR':
            return {...state, ...{ error: action.error }};

        case 'GET_PLAN_PROCESSING':
            return {...state, ...{ processing: action.processing }};

        default: return state;
    }
}